<section class="content">
    <div class="container-fluid">
        <!-- Small boxes (Stat box) -->
        <div class="row">
     
            <!-- ./col -->
          <div class="col-md-12">
            <!-- small box -->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Kullanıcı Listesi</h3>


              </div>
              <div class="card-body">





                <table class="table table-bordered">
                  <thead>
                    <tr>

                      <th>Eposta</th>
                      <th>Premium</th>

              
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let lang of users">


                      <td>{{lang.user.email}}</td>
                      <td>{{lang.premium}}</td>


                     
                    </tr>
                  </tbody>

                </table>




              </div>
              <!-- /.card-body -->
              <div class="card-footer"></div>
              <!-- /.card-footer-->
            </div>
          </div>
            <!-- ./col -->
           
            <!-- ./col -->
        </div>
        <!-- /.row -->
    </div>
    <!-- Main row -->
</section>